import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { id: "about" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("section", {
    id: "banner",
    style: { "background-image": "url('/images/about/main-01.jpg')" }
}, [
    /*#__PURE__*/ _createElementVNode("div", { class: "content" }, [
        /*#__PURE__*/ _createElementVNode("h1", null, "ABOUT")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { id: "content" };
const _hoisted_4 = {
    key: 0,
    class: "identity"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "IDENTITY")
], -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "SCHOOL NAME"),
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode(" Vincent Memorial Catholic High School"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" The school is named in honor of father Jean B. Vincent. ")
    ])
], -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "MOTTO"),
    /*#__PURE__*/ _createElementVNode("p", null, "Benedictus Deus / Blessed be God.")
], -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "MASCOT"),
    /*#__PURE__*/ _createElementVNode("p", null, "Scots.")
], -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "COLORS"),
    /*#__PURE__*/ _createElementVNode("p", null, "Blue, Gold and White.")
], -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "ACCREDITATION"),
    /*#__PURE__*/ _createElementVNode("p", null, " VMCHS was Accredited by the Western Association of Schools and Colleges (WASC) and the Western Catholic Education Association (WCEA) in the spring of 2018. Vincent received the maximum term allotted of 6 years to be accredited until 2025. ")
], -1 /* HOISTED */);
const _hoisted_11 = [
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10
];
const _hoisted_12 = {
    key: 1,
    class: "history"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "HISTORY")
], -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("p", null, " Vincent Memorial was originally opened as an all girl school, Our Lady of Guadalupe Academy in 1949. Thanks to the vision and dedication of Father Jean B. Vincent, pastor of Our Lady of Guadalupe Church in Calexico and the community of Sister Servants of the Blessed Sacrament, who worked at the parochial school since 1926, and after many fundraising activities and development efforts, land was purchased for what is now Vincent Memorial Catholic High School. The name was changed from Our Lady of Guadalupe Academy to Vincent Memorial High School when the school moved to its present location in 1966. The school had its first graduating class in 1967 under the administration of the Sister Servants of the Blessed Sacrament, who continue to serve in this school community. In the spring of 2002 Bishop Robert H. Brom allowed Vincent Memorial to add the word Catholic to its name in an effort to be known as a Catholic institution; hence the school name changed to Vincent Memorial Catholic High School (VMCHS). ", -1 /* HOISTED */);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", null, " More than 3,000 fine men and women have graduated from Vincent Memorial Catholic since it opened in its current location in 1966. Almost 100% of our students go on to higher education and many of them have made a difference in both the United States and Mexico – a strong statement to the dedication of a richly experienced faculty and the commitment of parents whose priorities lie in the future of their children. ", -1 /* HOISTED */);
const _hoisted_16 = [
    _hoisted_13,
    _hoisted_14,
    _hoisted_15
];
const _hoisted_17 = {
    key: 2,
    class: "mission"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "MISSION")
], -1 /* HOISTED */);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "MISSION"),
    /*#__PURE__*/ _createElementVNode("p", null, " In cooperation with parents, Vincent Memorial Catholic High School, a college-prep co-educational institution, strives to develop the spiritual, intellectual, emotional and physical aspects of the students so that they can take their place in society as mature, competent, informed and apostolic members of the local and global community. ")
], -1 /* HOISTED */);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h6", null, "PHILOSOPHY"),
    /*#__PURE__*/ _createElementVNode("p", null, " The philosophy of Vincent Memorial Catholic High School has been established in accord with the general philosophy of Christian education. The Catholic school in general and Vincent Memorial Catholic High School in particular, as an extension of the teaching Church, educates its students in order that they might reach union with God through the acquisition of truth and through loving relationships in the human community. ")
], -1 /* HOISTED */);
const _hoisted_21 = [
    _hoisted_18,
    _hoisted_19,
    _hoisted_20
];
const _hoisted_22 = {
    key: 3,
    class: "job-offert"
};
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "JOB OFFER")
], -1 /* HOISTED */);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("p", null, " Vincent Memorial is the only Catholic High School in the Imperial Valley. Since its founding in 1966, Vincent students, faculty, staff, alumni and the Sister Servants of the Blessed Sacrament have created a very special community- the Vincent Family! ", -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("p", null, " Whether you are a current Vincent Memorial employee or are interested in learning more about the career opportunities we offer, please visit the Diocesan website: ", -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("p", null, "http://www.diocese-sdiego.org", -1 /* HOISTED */);
const _hoisted_27 = [
    _hoisted_23,
    _hoisted_24,
    _hoisted_25,
    _hoisted_26
];
const _hoisted_28 = {
    key: 4,
    class: "staff"
};
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "STAFF")
], -1 /* HOISTED */);
const _hoisted_30 = { class: "title" };
const _hoisted_31 = ["src", "alt"];
const _hoisted_32 = { class: "information" };
const _hoisted_33 = { class: "name" };
const _hoisted_34 = { class: "ocupation" };
const _hoisted_35 = {
    key: 0,
    src: "/images/about/identity.jpg",
    alt: "Photo by Slidebean on Unsplash"
};
const _hoisted_36 = {
    key: 1,
    src: "/images/about/history.jpg",
    alt: "Photo by Portuguese Gravity on Unsplash"
};
const _hoisted_37 = {
    key: 2,
    src: "/images/about/mission.jpg",
    alt: "Photo by Jess Bailey on Unsplash"
};
const _hoisted_38 = {
    key: 3,
    src: "/images/about/job-offert.jpg",
    alt: "Photo by National Cancer Institute on Unsplash"
};
const _hoisted_39 = {
    key: 4,
    src: "/images/about/staff.jpg",
    alt: "Photo by Windows on Unsplash"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
            _createElementVNode("article", null, [
                _createVNode(_TransitionGroup, { name: "about-subsection" }, {
                    default: _withCtx(() => [
                        (_ctx.selection == 'identity')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_11))
                            : _createCommentVNode("v-if", true),
                        (_ctx.selection == 'history')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
                            : _createCommentVNode("v-if", true),
                        (_ctx.selection == 'mission')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
                            : _createCommentVNode("v-if", true),
                        (_ctx.selection == 'job-offert')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_27))
                            : _createCommentVNode("v-if", true),
                        (_ctx.selection == 'staff')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _hoisted_29,
                                (_ctx.staff)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.staff, (section, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                            _createElementVNode("div", _hoisted_30, _toDisplayString(index), 1 /* TEXT */),
                                            _createElementVNode("ul", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section, (emp) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: emp.id
                                                    }, [
                                                        _createElementVNode("figure", null, [
                                                            _createElementVNode("img", {
                                                                src: emp.image || `/images/staff/ph.jpg`,
                                                                alt: emp.name
                                                            }, null, 8 /* PROPS */, _hoisted_31)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_32, [
                                                            _createElementVNode("div", _hoisted_33, _toDisplayString(emp.name), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_34, _toDisplayString(emp.ocupation), 1 /* TEXT */)
                                                        ])
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _createElementVNode("menu", null, [
                _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                        class: _normalizeClass({ active: _ctx.selection == 'identity' })
                    }, [
                        _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.changeSubseccion('identity')), ["prevent"]))
                        }, "IDENTITY")
                    ], 2 /* CLASS */),
                    _createElementVNode("li", {
                        class: _normalizeClass({ active: _ctx.selection == 'history' })
                    }, [
                        _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.changeSubseccion('history')), ["prevent"]))
                        }, "HISTORY")
                    ], 2 /* CLASS */),
                    _createElementVNode("li", {
                        class: _normalizeClass({ active: _ctx.selection == 'mission' })
                    }, [
                        _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.changeSubseccion('mission')), ["prevent"]))
                        }, "MISSION")
                    ], 2 /* CLASS */),
                    _createElementVNode("li", {
                        class: _normalizeClass({ active: _ctx.selection == 'job-offert' })
                    }, [
                        _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.changeSubseccion('job-offert')), ["prevent"]))
                        }, "JOB OFFER")
                    ], 2 /* CLASS */),
                    _createElementVNode("li", {
                        class: _normalizeClass({ active: _ctx.selection == 'staff' })
                    }, [
                        _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.changeSubseccion('staff')), ["prevent"]))
                        }, "STAFF")
                    ], 2 /* CLASS */)
                ]),
                _createElementVNode("figure", null, [
                    (_ctx.selection == 'identity')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                        : _createCommentVNode("v-if", true),
                    (_ctx.selection == 'history')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                        : _createCommentVNode("v-if", true),
                    (_ctx.selection == 'mission')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_37))
                        : _createCommentVNode("v-if", true),
                    (_ctx.selection == 'job-offert')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                        : _createCommentVNode("v-if", true),
                    (_ctx.selection == 'staff')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ])
    ]));
}
